import { render, staticRenderFns } from "./TopMessage.vue?vue&type=template&id=293d664d&scoped=true&"
import script from "./TopMessage.vue?vue&type=script&lang=js&"
export * from "./TopMessage.vue?vue&type=script&lang=js&"
import style0 from "./TopMessage.vue?vue&type=style&index=0&id=293d664d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293d664d",
  null
  
)

export default component.exports